import type { JSX } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import AiIcon from "../../../shared/components/icons/AiIcon";
import t from "../../../shared/translations";
import type { Dispatch } from "../../state";
import { openModal } from "../../state";
import { Button } from "../stylings";

interface IProps {
    invert: boolean;
}

const StyledAiIcon = styled(AiIcon)`
    display: inline-block;
    vertical-align: middle;
    width: 44px;
    height: 44px;
    margin-left: -22px;
    margin-right: 12px;
    margin-top: -13px;
    margin-bottom: -13px;
`;

function HelpMeStartButton({ invert }: IProps): JSX.Element {
    const dispatch = useDispatch<Dispatch>();

    const open = () => {
        dispatch(openModal("Task/AiAssist"));
    };

    return (
        <Button $invert={invert} type="button" onClick={open}>
            <StyledAiIcon white />
            {t("player.task.button-ai-assist-start")}
        </Button>
    );
}

export default HelpMeStartButton;
